import React, { useState, useRef, useEffect } from "react";

import { Grid, Button, ButtonGroup, Menu, MenuItem } from "@mui/material";

import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
  GridFooterContainer,
  GridRowCount,
  GridFooter,
  useGridApiContext,
} from "./PersistedDataGridPro";

import Grow from "@mui/material/Grow";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TableChartIcon from "@mui/icons-material/TableChart";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const ExportMenu = ({ csvOptions, onExportExcel, onExportPdf, fullWidth }) => {
  const apiRef = useGridApiContext();
  const [anchorEl, setAnchorEl] = useState(null);

  const runExport = (callback) => {
    setAnchorEl(null);
    callback();
  };

  return (
    <>
      <Button
        color="primary"
        startIcon={<FileDownloadIcon />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        sx={fullWidth ? { width: "100%", justifyContent: "flex-start" } : {}}
      >
        Esporta
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() =>
            runExport(() => apiRef.current.exportDataAsCsv(csvOptions))
          }
        >
          <FileDownloadIcon sx={{ mr: 1 }} /> Esporta in CSV
        </MenuItem>
        {onExportExcel && (
          <MenuItem onClick={() => runExport(onExportExcel)}>
            <TableChartIcon sx={{ mr: 1 }} /> Esporta in Excel
          </MenuItem>
        )}
        {onExportPdf && (
          <MenuItem onClick={() => runExport(onExportPdf)}>
            <PictureAsPdfIcon sx={{ mr: 1 }} /> Stampa PDF
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export const CustomFooterPersonalized = ({
  csvOptions,
  onExportExcel,
  onExportPdf,
}) => {
  const [screenSize, getDimension] = useState(window.innerWidth);
  const setDimension = () => {
    getDimension(window.innerWidth);
  };
  const anchorRef = useRef(null);
  const [openButton, setOpenButton] = useState(false);

  const handleToggleButton = () => {
    setOpenButton(!openButton);
  };
  const handleCloseButton = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenButton(false);
  };

  useEffect(() => {
    window.addEventListener("resize", setDimension);
    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);
  return (
    <>
      <GridFooterContainer
        sx={{
          display: "flex",
          justifyContent: { xs: "center", md: "flex-start" },
          px: 2,
          flexWrap: { xs: "wrap", md: "nowrap" },
        }}
      >
        {screenSize > "768" ? (
          <>
            <GridToolbarColumnsButton id="GridFooterColumnsButton" />
            <GridToolbarFilterButton
              id="GridFooterColumnsButton"
              style={{
                color: "#11526F",
                backgroundColor: "transparent",
                boxShadow: "none",
                border: 0,
              }}
            />
            <GridToolbarDensitySelector id="GridFooterColumnsButton" />
            {onExportExcel || onExportPdf ? (
              <ExportMenu
                csvOptions={csvOptions}
                onExportExcel={onExportExcel}
                onExportPdf={onExportPdf}
              />
            ) : (
              <GridToolbarExport
                id="GridFooterColumnsButton"
                csvOptions={csvOptions}
              />
            )}

            <GridFooter
              id="CounterFooter"
              style={{
                float: "right",
                backgroundColor: "transparent",
                boxShadow: "none",
              }}
            />
          </>
        ) : (
          <>
            <ButtonGroup
              aria-label="split button"
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                ref={anchorRef}
                startIcon={
                  <MoreVertIcon style={{ height: "28px", width: "28px" }} />
                }
                variant="contained"
                className="ButtonToolbarWrapped"
                onClick={() => {
                  handleToggleButton();
                }}
                size="small"
              >
                <span
                  style={{
                    margin: "0  0 0 -10px",
                    alignSelf: "center",
                    fontSize: "16px",
                    textTransform: "capitalize",
                  }}
                >
                  Opzioni tabella
                </span>
              </Button>
              <Popper
                sx={{
                  zIndex: 100,
                }}
                open={openButton}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
              >
                {({ TransitionProps, placement }) => (
                  <Grow {...TransitionProps}>
                    <Paper sx={{ width: "181px" }}>
                      <ClickAwayListener onClickAway={handleCloseButton}>
                        <MenuList id="split-button-menu" Item sx={{ p: 0 }}>
                          <MenuItem
                            key={1}
                            onClick={handleToggleButton}
                            sx={{ p: 0 }}
                          >
                            <GridToolbarColumnsButton
                              sx={{ color: "#11526F" }}
                              style={{
                                border: 0,
                                width: "100%",
                                padding: "10px 32px 10px 20px ",
                                justifyContent: "flex-start",
                              }}
                            />
                          </MenuItem>
                          <MenuItem
                            key={0}
                            onClick={handleToggleButton}
                            sx={{ p: 0 }}
                          >
                            <GridToolbarFilterButton
                              sx={{ color: "#11526F" }}
                              style={{
                                border: 0,
                                width: "100%",
                                padding: "10px 32px 10px 15px ",

                                justifyContent: "flex-start",
                              }}
                              fullWidth
                            />
                          </MenuItem>

                          <MenuItem key={2} sx={{ p: 0 }}>
                            <GridToolbarDensitySelector
                              sx={{ color: "#11526F" }}
                              style={{
                                border: 0,
                                width: "100%",
                                padding: "10px 32px 10px 18px ",

                                justifyContent: "flex-start",
                              }}
                            />
                          </MenuItem>
                          <MenuItem key={3} sx={{ p: 0 }}>
                            {onExportExcel || onExportPdf ? (
                              <ExportMenu
                                csvOptions={csvOptions}
                                onExportExcel={onExportExcel}
                                onExportPdf={onExportPdf}
                                fullWidth
                              />
                            ) : (
                              <GridToolbarExport
                                csvOptions={csvOptions}
                                sx={{ color: "#11526F" }}
                                style={{
                                  border: 0,
                                  width: "100%",
                                  padding: "10px 32px 10px 18px ",
                                  justifyContent: "flex-start",
                                }}
                              />
                            )}
                          </MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </ButtonGroup>
          </>
        )}
        {/*  */}
      </GridFooterContainer>
    </>
  );
};
